<template>
  <div class="bb-px2pt6 border-box">
    <div v-show="userLoggedIn" class="clearfix">
      <div class="xl-col xl-col-6 bb-xl-max-w55 center bb-xl-left-align">
        <div class="relative bb-mt3pt56">
          <div 
          class="absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1
          xs-hide sm-hide md-hide lg-hide"></div>
          <div class="bb-ff2 bb-fs1pt2 bb-fc1">
            {{ $lang.messages.select_experience }}
          </div>
        </div>
        <div class="clearfix">
          <div class="xl-col bb-ff2 bb-fs1pt2 bb-fc4 mt2">
          VR EXPERIENCE :
          </div>
          <div
          class="xl-col xl-col-8 bb-ff2 bb-fs1pt2 bb-fc3 mt2 bb-xl-mt2 bb-xl-pl2 border-box">
            {{selectedOptions.experienceName}}
          </div>
        </div>
        <div class="clearfix">
          <div class="xl-col bb-ff2 bb-fs1pt2 bb-fc4 mt2">
            {{ $lang.messages.your_booking }} :
          </div>
          <div
          class="xl-col xl-col-8 bb-ff2 bb-fs1pt2 bb-fc3 mt2 bb-xl-mt2 bb-xl-pl2 border-box">
            {{ selectedOptions.timestamp }}
          </div>
        </div>
        <div class="clearfix">
          <div class="xl-col bb-ff2 bb-fs1pt2 bb-fc4 mt2">
            {{ $lang.messages.total_payment }} :
          </div>
          <div
            class="xl-col xl-col-3 bb-ff2 bb-fs1pt2 bb-fc3 mt2 bb-xl-pl2">
            ${{selectedOptions.selectedPlaces *
            selectedOptions.sessionData.price}}
          </div>
        </div>
      </div>
      <div class="xl-col xl-col-6 bb-xl-max-w55 center bb-xl-left-align">
        <div class="relative bb-mt3pt56">
          <div 
          class="absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1
          xs-hide sm-hide md-hide lg-hide"></div>
          <div class="bb-ff2 bb-fs1pt2 bb-fc1">
            {{ $lang.messages.payment_method_title }}
          </div>
        </div>
        <div
        class="bb-ff2 bb-fs1pt29 bb-fc3 mt2">
          {{ $lang.messages.payment_method1 }}
        </div>
        <div class="center mx-auto border-box bb-pointer bb-sm-bc-transp
          bb-ff3 bb-fs1 bb-brd4 bb-h2pt8 bb-py1pt25 bb-lh0
          bb-transition2 mb3 bb-mt1pt7 relative bb-mxw31pt3 bb-xl-ml0"
          @click="payment"
          :class="[ loadingPayfort ? 'bb-fc13' : 'bb-bc9 bb-fc1 bb-sm-fc3 bb-fc1-hover' ]">
          {{ $lang.messages.pay_method1 }}
          <div class="absolute bb-vhcr bb-h90p bb-w100p" v-if="loadingPayfort">
            <img class="bb-h100p" src="../assets/images/green-loader.svg"></img>
          </div>
        </div>
        <div class="clearfix">
          <div
          class="bb-ff2 bb-fs1pt29 bb-fc3 mt1">
            {{ $lang.messages.payment_method2 }}
          </div>
        </div>
        <div class="border-box bb-mxw31pt3 bb-xl-ml0 mt3 mx-auto relative">
          <div class="absolute left-0 bb-top1 bb-transform1 bb-fc1 bb-ff2 bb-zindex0"
            :class="{'bb-transform2': inputVoucherActive}">
            {{ $lang.messages.voucher_code }}
          </div>
          <input type="text"
            class="bb-bc-transp border-box mx-auto
            bb-ff2 bb-fs1 bb-w100p bb-h2pt8 bb-brd-top0
            bb-brd-left0 bb-brd-right0 p0 bb-fc1 relative bb-zindex1"
            :class="[invalidVoucherCode ? 'bb-brd5 bb-fc5' : 'bb-brd-bot1 bb-fc1']"
            v-model="voucherCode"
            @blur="blurVoucherPlaceholder"
            @change="resetValidation"
            @focus="inputVoucherClicked">
        </div>
        <div class="center mx-auto border-box bb-pointer bb-sm-bc-transp
          bb-ff3 bb-fs1 bb-brd3 bb-mxw31pt3 bb-xl-ml0
          bb-h2pt8 bb-py1pt25 bb-lh0 bb-transition2 bb-mt1pt7 relative"
          @click="voucher"
          :class="[ loadingVoucher ? 'bb-fc13' : 'bb-bc2 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-bc2-hover' ]">
          {{ $lang.messages.pay_method2 }}
          <div class="absolute bb-vhcr bb-h90p bb-w100p" v-if="loadingVoucher">
            <img class="bb-h100p" src="../assets/images/loader.svg"></img>
          </div>
        </div>
      </div>
    </div>
    <!-- this form is responsible for taking the user to payfort gateway -->
    <form v-if="formData" :method="formData.req.method"
      :action="formData.req.url" id="form1">  
      <input v-for="(value, key) in formData.req.payfort" type="hidden"
      :name="key" :value="value"><br>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Checkout',
  data () {
    return {
      loadingPayfort: false,
      loadingVoucher: false,
      inputVoucherActive: false,
      voucherCode: '',
      invalidVoucherCode: false,
      formDataReceived: false
    }
  },
  computed: {
    formData () {
      if (this.$store.getters.getActivity !== null) {
        this.formDataReceived = true
        return this.$store.getters.getActivity
      }
    },
    voucherFeedback () {
      return this.$store.getters.getVoucherActivity
    },
    selectedOptions () {
      return this.$store.getters.getSelectedOptions
    },
    voucherError () {
      return this.$store.getters.getVoucherError
    }
  },
  watch: {
    formDataReceived: function () {
      this.loading = false
      this.$nextTick(function () {
        document.getElementById('form1').submit()
      })
    },
    voucherError: function () {
      this.loadingVoucher = false
      this.invalidVoucherCode = true
      this.$store.commit('SET_DISPLAY_NOTIFICATION', {show: true,
      msg:this.$lang.messages.err4, state: false})
    },
    voucherCode: function () {
      if (this.invalidVoucherCode) {
        this.invalidVoucherCode = false
      }
    },
    voucherFeedback: function () {
      this.$router.push({
        path: '/${this.selectedOptions.experienceId}/${this.voucherFeedback.id}/confirmation'
      })
    }
  },
  methods: {
    payment: function () {
      this.loadingPayfort = true
      var params = {
        token: this.$localStorage.get('token'),
        pId: this.$localStorage.get('profileId')
      }
      this.$store.dispatch('LOAD_PAYFORT', params)
    },
    voucher: function () {
      this.loadingVoucher = true
      if (this.voucherCode !== '') {
        var voucherParams = {
          voucherCode: this.voucherCode,
          profileId: this.$localStorage.get('profileId'),
          profileToken: this.$localStorage.get('token'),
        }
        this.$store.dispatch('LOAD_VOUCHER', voucherParams)
      } else {
        this.loadingVoucher = false
        this.invalidVoucherCode = true
        this.$store.commit('SET_DISPLAY_NOTIFICATION', {show: true,
        msg:this.$lang.messages.err4, state: false})
      }
    },
    resetPlaceholder: function (event, placeholder) {
      event.target.placeholder = placeholder
    },
    blurVoucherPlaceholder: function (event) {
      if (event.target.value.length <= 0) {
        this.inputVoucherActive = false
      }
    },
    inputVoucherClicked: function () {
      this.inputVoucherActive = true 
    },
    resetValidation: function () {
      if (this.invalidVoucherCode) {
        this.invalidVoucherCode = false
      }
    }
  },
  created() {
    if (this.selectedOptions
        && this.selectedOptions.experienceId) {
      this.forceLogin()
    } else {
      this.$router.push({ name: 'Home' })
    }
  },
  beforeDestroy () {
    this.loadingPayfort = false 
    this.loadingVoucher = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/checkout.vue